import React from 'react';
import ResetPassword from '../../components/authComponents/resetPassword';

const Page = () => <ResetPassword />;

export default Page;
